(function ($, Drupal, once, drupalSettings) {
  Drupal.behaviors.botFrameworkWebChat = {
    attach: function (context, settings) {
      
      var buttonText = $('.chatbotbutton-text').text().replace(/\s+/g, ' ').trim();
      $('.btn-ask-ai span').text(buttonText);
      const chatbotSettings = drupalSettings.chatbot || {};
      const chatbotLink = chatbotSettings.link || '';
      const chatbotPlaceholder = chatbotSettings.placeholder || '';
      var chatbotStatus = $('.chatbot-status').text().replace(/\s+/g, ' ').trim();
      var isChatbotEnabled = chatbotStatus === '1';

      if (isChatbotEnabled) {
        // Show chatbot open button and AI search button
        $('#chatbotOpen').show();
        $('.svg-on').show();
      } else {
        // Hide chatbot open button and AI search button
        $('#chatbotOpen').hide();
        $('.svg-off').show();
      }   
      var chatbotTimings = $('.chatbot-date').text().trim();
      $('.chatbot-time').text(chatbotTimings);

      // Regex to extract last two HH:MM time strings
      var times = chatbotTimings.match(/(\d{1,2}:\d{2})/g);
      if (isChatbotEnabled && times && times.length >= 2) {
        var startTimeStr = times[times.length - 2]; // second last time
        var endTimeStr   = times[times.length - 1]; // last time
      
        function timeToMinutes(timeStr) {
          var t = timeStr.split(':');
          return parseInt(t[0], 10) * 60 + parseInt(t[1], 10);
        }
      
        var startMinutes = timeToMinutes(startTimeStr);
        var endMinutes   = timeToMinutes(endTimeStr);
      
        var now = new Date();
        var currentMinutes = now.getHours() * 60 + now.getMinutes();
      
        if (currentMinutes >= startMinutes && currentMinutes <= endMinutes) {
          // Within timing → show ON state
          $('#chatbotOpen').show();
          $('.svg-on').show();
          $('.svg-off').hide();
        } else {
          // Outside timing → show OFF state
          $('#chatbotOpen').hide();
          $('.svg-on').hide();
          $('.svg-off').show();
        }
      } else {
        console.warn('Could not parse chatbot timings:', chatbotTimings);
      }

      once('botFrameworkWebChat', '#webchat', context).forEach(function (element) {

        // expose initWebChat immediately, but only called on click.
        window.initWebChat = function() {

          // Only initialize if WebChat library exists
          if (!window.WebChat) {
            return; // silently exit if library not loaded yet
          }

          var styleSet = window.WebChat.createStyleSet({
            // This CSS is required here because it will be applied dynamically.
            bubbleBackground: '#0397D6',
            bubbleFromUserBackground: '#F7F9FF',
            bubbleTextColor: '#FFFFFF',
            bubbleFromUserTextColor: 'black',
            rootHeight: '500px',
            rootWidth: '100%',
            bubbleBorderRadius: 10,
            bubbleFromUserBorderRadius: 10,
            typingAnimationBackgroundImage: 'url(/themes/custom/hq/img/typing-dots.svg)',
            typingAnimationHeight: 50,
            typingAnimationWidth: 64
          });

          function startNewConversation() {          
            window.fetch(chatbotLink)
              .then(function (response) { return response.json(); })
              .then(function (conversationInfo) {
                var directLine = window.WebChat.createDirectLine({
                  token: conversationInfo.token
                });

                window.WebChat.renderWebChat(
                  {
                    directLine: directLine,
                    styleSet: styleSet,
                    styleOptions: {
                      hideUploadButton: true,
                      botAvatarImage: '/themes/custom/hq/img/ai.svg',
                      botAvatarInitials: 'AI',
                    }
                  },
                  element
                );

                var observer = new MutationObserver(function (mutations, obs) {
                  var inputBox = element.querySelector('.webchat__send-box-text-box__input');
                  if (inputBox) {
                    // Set placeholder once input is ready
                    inputBox.setAttribute('placeholder', chatbotPlaceholder);
                    obs.disconnect(); // stop observing once placeholder is set
                  
                    // Add listener for input actions
                    function hideWelcomeIfNotEmpty() {
                      var welcomeText = document.querySelector('.field--name-field-welcome-text');
                      if (welcomeText && inputBox.value.trim() !== '') {
                        welcomeText.style.display = 'none';
                      }
                    }
                  
                    // Hide when clicking send button
                    element.addEventListener('click', function (e) {
                      if (e.target.closest('.webchat__icon-button')) {
                        hideWelcomeIfNotEmpty();
                      }
                    });
                  
                    // Hide when pressing Enter key
                    element.addEventListener('keydown', function (e) {
                      if (e.key === 'Enter') {
                        hideWelcomeIfNotEmpty();
                      }
                    });
                  }
                });
                observer.observe(element, { childList: true, subtree: true });
              })
              .catch(function (err) { console.error('An error occurred: ', err); });
          }

          startNewConversation();

        }; // end of initWebChat

        // === ATTACH initWebChat TO CLICK ===
        var openBtn = document.getElementById('chatbotOpen');
        if (openBtn) {
          openBtn.addEventListener('click', function() {
            window.initWebChat(); // call only on click
          });
        }

        // === Modal Toggle ===
        var modal = document.getElementById('chatbotModal');
        var closeBtn = document.getElementById('chatbotClose');

        function openModal() {
          modal.classList.remove('hidden');
          document.body.style.overflow = 'hidden'; // disable background scroll
          document.body.classList.add('chatbot-open');
          // Disable navbar scroll (on mobile)
          const navbar = document.querySelector('.region-navbar');
          if (navbar) {
            navbar.style.overflow = 'hidden';
          }
        }

        function closeModal() {
          modal.classList.add('hidden');
          document.body.style.overflow = ''; // enable background scroll
          document.body.classList.remove('chatbot-open');
          const navbar = document.querySelector('.region-navbar');
          if (navbar) {
            navbar.style.overflow = ''; // or scroll if you prefer
          }
        }

        if (openBtn) {
          openBtn.addEventListener('click', openModal);
        }

        if (closeBtn) {
          closeBtn.addEventListener('click', closeModal);
        }

        // Close when clicking outside content
        if (modal) {
          modal.addEventListener('click', function (e) {
            if (e.target === modal) {
              closeModal();
            }
          });

          // Close on Esc key
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' || e.key === 'Esc') {
              if (!modal.classList.contains('hidden')) {
                closeModal();
              }
            }
          });
        }

      });
    }
  };
})(jQuery, Drupal, once, drupalSettings);
